import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import { es } from "date-fns/locale";
import LocalizedStrings from "react-localization";
import moment from "moment";

import "react-day-picker/dist/style.css";

const DateRangeForm = ({ initialValues, onSubmit, withHours = false }) => {
  const [dateRange, setDateRange] = useState({
    from: moment().startOf("day").toDate(),
    to: moment().endOf("day").toDate(),
  });

  const [hours, setHours] = useState({
    hourFrom: "",
    hourTo: "",
  });

  const onChange = (e) => {
    let { name, value } = e.target;

    setHours((prevSt) => ({
      ...prevSt,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (initialValues?.from) {
      const { from, to } = initialValues;

      setDateRange({ from, to });
      if (withHours)
        setHours({
          hourFrom: moment(from).format("HH:mm"),
          hourTo: moment(to).format("HH:mm"),
        });
    }
  }, [initialValues, withHours]);

  return (
    <Grid padding="20px">
      <DayPicker
        style={{ justifySelf: "center", marginTop: "0px" }}
        locale={es}
        id="datePicker"
        mode="range"
        defaultMonth={initialValues?.from ?? new Date()}
        selected={dateRange}
        onSelect={setDateRange}
      />

      {withHours && (
        <Grid
          rowGap={10}
          style={{
            justifySelf: "center",
            width: "250px",
            marginBottom: "15px",
          }}
        >
          <TextField
            type="time"
            name="hourFrom"
            label={strings.fields.startSchedule.label}
            value={hours.hourFrom}
            onChange={onChange}
          ></TextField>
          <TextField
            type="time"
            name="hourTo"
            label={strings.fields.endSchedule.label}
            value={hours.hourTo}
            onChange={onChange}
          ></TextField>
        </Grid>
      )}

      <Flex style={{ justifySelf: "center" }}>
        <Button
          children={strings.fields.buttons.save}
          onClick={() => onSubmit({ ...dateRange, ...hours })}
          variation="primary"
          isDisabled={!dateRange?.from || !dateRange?.to}
        ></Button>
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      startDate: {
        label: "Fecha Inicio",
      },
      endDate: {
        label: "Fecha Fin",
      },
      startSchedule: {
        label: "Hora de Inicio",
      },
      endSchedule: {
        label: "Hora de Fin",
      },
      buttons: {
        save: "Guardar",
      },
    },
  },
});

export default DateRangeForm;
